import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useGridDecorativeLabelStyle = makeStyles({
  tilesGridCellDecorativeLabel: {
    color: tokens.colorNeutralForegroundInverted,
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',

    '& .label-icon-and-text': {
      display: 'flex',
      ...shorthands.borderRadius('4px'),
      ...shorthands.padding('2px', '8px', '2px', '4px'),
      marginRight: '6px',
      // background: 'linear-gradient(158.29deg, #0078D4 16.69%, #4400D4 85.76%)',
      backgroundColor: tokens.colorNeutralBackgroundStatic,
      '& .label-icon': {
        marginRight: '4px',
        fontSize: '16px',
      },
    },

    '& .label-secondary-text': {
      position: 'relative',
      left: '-10px',
      opacity: 0,
      ...shorthands.transition('opacity', '0.5s', '0.1s', 'transform', '0.3s', '0.1s'),
    },

    '& .additional-icon-content': {
      width: '25px',
      height: '24px',
      backgroundColor: 'rgb(50,49,48, 0.6)',
      ...shorthands.borderRadius('4px'),
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      marginRight: '8px',
      position: 'absolute',
      right: '50px',
      '& .additional-icon': {
        width: '17px',
      },
    },

    '& .label-additional-text': {
      position: 'absolute',
      right: '0px',
      '& .label-additional-content': {
        backgroundColor: tokens.colorNeutralBackgroundStatic,
        float: 'right',
        ...shorthands.padding('4px'),
        ...shorthands.borderRadius('4px'),
      },
    },
  },

  cellLabelDisplay: {
    display: 'flex',
    alignItems: 'center',
  },
});
